<template>
    <form id="email-change-form" class="w-100 form account-settings">
        <small v-if="errors && errors.General" class="text-danger">{{ errors?.General }}</small>
        <div class="w-full d-flex gap-3 align-items-end">
            <TextInput type="email" v-model:modelValue="email" label="Email Address" placeholder='Enter Email' :error="errors?.email ?? null" :max=100 />
            <button type="submit" class="btn btn-primary toggle-control lh-sm" @click.prevent="handleSubmit" @keypress.enter.prevent="handleSubmit"> Update </button>
        </div>
    </form>
  </template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { useModalStore } from '@/stores/modal';
import { useParticipantStore } from '@/stores/participant';
import TextInput from '@components/form/TextInput.vue';
import axios from 'axios';
import { useAuthStore } from '@/stores/auth';

export default defineComponent({
components: {
    TextInput,
},

setup(_, { emit}) {
    const modalStore = useModalStore();
    const email = ref<string>(useAuthStore().userEmail ?? '');
    const errors = ref<Record<string, string>>({General: ''});
    const success = ref('');

    const validateEmail = async (email: string) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const emailErrors  = await useParticipantStore().checkUser(email);
        errors.value.General = 'Invalid email. Please check and ensure it meets the required validation criteria.';

        if(email === useParticipantStore().userEmail) {
            errors.value.General = 'Email should be different from the old one.';
            return false;
        }

        if(emailErrors?.length) {
            errors.value.General = emailErrors.join('. ');
            return false;
        }

        return emailRegex.test(email);
    }

    const handleSubmit = async () => {
        if (await validateEmail(email.value)) {
            errors.value.General = '';

            emit('email-verified')

            // useModalStore().openModal(
            //     'validate-user-2fa',
            //     'Verify Email Address',
            //     'modal-success',
            //     null,
            //     {
            //         onConfirm: () => {
            //             const response = submitData(email.value);
            //         }
            //     },
            //     null,
            //     null,
            //     {email: email.value, method: 'E'}
            // );
        }
    }

    return {
        email,
        success,
        errors,
        handleSubmit,
    };
},
});
</script>
